import { setGlobalPopupElement } from "@/store/features/globalSlice";
import { useAppDispatch } from "@/store/hooks";

export default function PopupManager({ 
  children,
  onClose,
}: { 
  children: React.ReactNode;
  onClose?: () => void;
}) {
    const dispatch = useAppDispatch()

  const handleClose = () => {
    if (onClose) onClose()
    else dispatch(setGlobalPopupElement(null))
  }

  return (
    <div className='fixed w-full h-full bg-black/20 inset-0 z-[1300] flex items-center justify-center'>
      <div className='absolute left-0 right-0 w-full h-full -z-10' onClick={handleClose}></div>
      <div className='relative'>
        <button
          className='absolute top-0 right-0 p-2 bg-primary-white rounded-full translate-x-1/2 -translate-y-1/2'
          onClick={handleClose}
        >
            <svg className='w-4 h-4' viewBox='0 0 24 24'>
                <path fill='currentColor' d='M12 10.586L16.95 5.636a1 1 0 111.414 1.414L13.414 12l4.95 4.95a1 1 0 11-1.414 1.414L12 13.414l-4.95 4.95a1 1 0 11-1.414-1.414L10.586 12 5.636 7.05a1 1 0 111.414-1.414L12 10.586z'></path>
            </svg>
        </button>

        {children}
      </div>
    </div>
  )
}